import { AuthService } from '@apparel/core/auth';
import { useService } from '@apparel/react/hooks/useService';
import Button, { ButtonProps } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import React, { useCallback, useState } from 'react';
import { useNewAuthDialog } from '../auth/AuthButtons/NewAuthDialog/NewAuthDialogContext';
import { CartService } from './CartService';

// import { CartEmitter, CartEvents }      from './CartEmitter';
// import { call }                         from '@apparel/core/utils/functions';

export const CartCheckout = React.memo(({ onClick, ...rest }: ButtonProps) => {
    const cart$ = useService(CartService);
    const newDialog$ = useNewAuthDialog();

    const [loading, setLoading] = useState(false);

    const onSignIn = useCallback(async () => {
        newDialog$.setOpen(false);

        // CartEmitter.emit(CartEvents.DROPDOWN_SHOW, false);

        try {
            const { data } = await cart$.order();

            // TODO: implement general notification system
            // await notify.success('Success! Now is time to complete your Designs & Roster.');
            // TODO: implement general Router system
            // router.goTo('Order.orderForm', { tab: 'roster-designs', order: data.id });
            window.location.href = `/platform/orders/create/${data.id}/designs`;
        } catch (e) {
            // await notify.error(e.response || 'Something went wrong, Order couldn\'t be placed!');
            window.location.href = '/platform/sign-in?u=%2Fmy-cart%2Freview';
        }

        // await call(onClick, e);
        setLoading(false);
    }, [setLoading]);

    const handleClick = useCallback(async () => {
        setLoading(true);
        if (!AuthService.getInstance().isAuthenticated()) {
            newDialog$.setOpen(true);
            newDialog$.setOnEnd(() => onSignIn);
            setLoading(false);
            return;
        }

        onSignIn();
    }, [onClick, onSignIn]);

    return (
        <Button
            disableElevation
            color={'primary'}
            variant={'contained'}
            startIcon={loading ? <CircularProgress color={'inherit'} size={24} /> : null}
            onClick={handleClick}
            {...rest}
        >
            Checkout
        </Button>
    );
});

export default CartCheckout;
